import type { ReactNode, SVGProps } from "react";

export function CircleIcon(props: SVGProps<SVGSVGElement>): ReactNode {
	return (
		<svg
			fill="none"
			height="5"
			viewBox="0 0 5 5"
			width="5"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<circle cx="2.5" cy="2.5" fill="currentColor" r="2.5" />
		</svg>
	);
}
